// creatie-message.jsx
import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import '../styles/creatie-message.css';

const CreatieMessage = ({ 
 isOpen = true, 
 onClose, 
 title = "Creatieve Uitdaging",
 message 
}) => {
 const [displayedMessage, setDisplayedMessage] = useState('');
 const [currentCharIndex, setCurrentCharIndex] = useState(0);
 const [showPrompt, setShowPrompt] = useState(false);

 useEffect(() => {
   if (!isOpen) {
     setDisplayedMessage('');
     setCurrentCharIndex(0);
     setShowPrompt(false);
     return;
   }

   if (currentCharIndex < message.length) {
     const timer = setTimeout(() => {
       setDisplayedMessage(prev => prev + message[currentCharIndex]);
       setCurrentCharIndex(prev => prev + 1);
     }, 30);
     return () => clearTimeout(timer);
   } else {
     setShowPrompt(true);
   }
 }, [isOpen, message, currentCharIndex]);

 const handleStart = () => {
   const element = document.querySelector('.creatie-window');
   element.classList.add('fade-out');
   setTimeout(onClose, 500);
 };

 if (!isOpen) return null;

 return (
   <div className="creatie-window">
     <div className="creatie-container">
       <div className="creatie-header">
         <div className="header-dots">
           <span></span>
           <span></span>
           <span></span>
         </div>
         <span className="header-title">{title}</span>
         <button onClick={onClose}>
           <X size={20} />
         </button>
       </div>

       <div className="creatie-content">
         <div className="creatie-text">
           {displayedMessage}
         </div>

         {showPrompt && (
           <div className="creatie-prompt" onClick={handleStart}>
             <span className="prompt-text">begin</span>
             <span className="prompt-cursor"></span>
           </div>
         )}
       </div>
     </div>
   </div>
 );
};

export default CreatieMessage;